module.exports = __webpack_public_path__ + "downloads/ValueType.e2313572.xlsx";